import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('recipes'))
  },

  async getSingle (id) {
    return store.dispatch('checkResponseApi', await Api().get(`recipes/${id}`))
  },

  async insert (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('recipes', data, options))
  },

  async update (id, data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put(`recipes/${id}`, data, options))
  },

  async delete (id, data = {}) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete(`recipes/${id}`, { data: data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/RecipeService.js